export const accessLocalStorage = (type) => {
    if (
        // localStorage.getItem(type) === null
        // || localStorage.getItem(type) === 'undefined'
        // || 
        [null, undefined, 'undefined', 'null'].includes(localStorage.getItem(type))
    ) {
        //console.log(`${type} not found in LocalStorage`)
        return null;
        // throw new Error(`${type} not found`);
    }
    return localStorage.getItem(type)
};